import { Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_shapes.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("wrappers_shapes.wrap"),
        name: (
          <div
            style={{
              backgroundColor: "#EFEFEF",
              borderRadius: "25px",
              width: "fit-content",
              padding: "3px 15px",
            }}
          >
            <Typography color="#1A1A1A" fontSize="18px" fontFamily="Cairo">
              {data?.wrap?.name}
            </Typography>
          </div>
        ),
      },
      {
        label: t("wrappers_shapes.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("wrappers_shapes.show_in_packaging"),
        name:
          data?.show_in_packaging === true
            ? t("common.yes")
            : data?.show_in_packaging === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_shapes.is_active"),
        name:
          data?.is_active === true
            ? t("common.yes")
            : data?.is_active === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_shapes.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("wrappers_shapes.dimensions"),
    icon: icons?.dimensions,
    details: [
      {
        label: t("wrappers_shapes.weight"),
        name: data?.weight || 0,
        width: "30%",
      },
      {
        label: t("wrappers_shapes.width"),
        name: data?.dimensions?.width || 0,
        width: "30%",
      },
      {
        label: t("wrappers_shapes.height"),
        name: data?.dimensions?.height || 0,
        width: "30%",
      },
      {
        label: t("wrappers_shapes.depth"),
        name: data?.dimensions?.length || 0,
        width: "30%",
      },
      {
        label: t("wrappers_shapes.volume"),
        name: data?.volume || 0,
        width: "30%",
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons?.priceIcon,
    details: [
      {
        label: t("wrappers_shapes.price"),
        name: `${data?.price} ${data?.currency?.name}`,
      },
      {
        label: t("wrappers_shapes.price_after_discount"),
        name: `${data?.price_after_discount} ${data?.currency?.name}`,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
